import { connect } from "react-redux";
import Delivery from "./Delivery";
import { getStoreCode } from "../../../../state/modules/regionalStore";
import {
  getDeliveryPriceText,
  getDeliveryOptionName
} from "../../../../state/modules/bag";

const mapStateToProps = state => ({
  storeCode: getStoreCode(state),
  text: getDeliveryPriceText(state),
  name: getDeliveryOptionName(state)
});

export default connect(mapStateToProps)(Delivery);
